import Badge from "react-bootstrap/Badge";

import "./TeacherBadge.css";

function TeacherBadge() {
  return <Badge className="bg_b"> Вчителька &nbsp;</Badge>;
}

export default TeacherBadge;
